export enum Breakpoints {
  LARGE_DESKTOP = "1200px",
  DESKTOP = "992px",
  TABLET = "768px",
  PHONE = "576px",
}
